import { periodKey } from '@/lib/reports-utils'
import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { ReportsTypes } from '../actions/actions.types'

type ReportsState = ApplicationState['reports']

const defaultReportsState: ReportsState = {
	overview: {},
	flights: {},
	hotels: {},
	cars: {},
	rails: {},
	travelers: {},
	meta: {
		offices: [],
		departments: [],
		accounting_unit: [],
		action_code: [],
		billable: [],
		cost_center: [],
		countries: [],
		internal_account: [],
		invoice_profiles: [],
		project_code: [],
		purchase_order_number: [],
		trip_purpose: [],
		custom_field_1: [],
		custom_field_2: [],
		custom_field_3: [],
		employee_id: [],
		out_of_policy_reason: [],
	},
	filters: {
		period: 'past-3-months',
		office: null,
		accounting_unit: null,
		action_code: null,
		billable: null,
		cost_center: null,
		country_id: null,
		internal_account: null,
		invoice_profile_id: null,
		project_code: null,
		department: null,
		purchase_order_number: null,
		trip_purpose: null,
		custom_field_1: null,
		custom_field_2: null,
		custom_field_3: null,
		employee_id: null,
		out_of_policy_reason: null,
	},
}

function reportsReducer(state: ReportsState = defaultReportsState, action: IAction): ReportsState {
	switch (action.type) {
		case ReportsTypes.GetOverview.SUCCESS:
			return {
				...state,
				overview: { ...state.overview, [periodKey(state.filters.period)]: action.payload[0] },
			}
		case ReportsTypes.GetMeta.SUCCESS:
			return {
				...state,
				meta: action.payload,
			}
		case ReportsTypes.SetFilters:
			return {
				...state,
				filters: action.payload,
				flights: {},
				hotels: {},
				rails: {},
				travelers: {},
			}
		case ReportsTypes.UpdateFilters:
			return { ...state, filters: { ...state.filters, ...action.payload } }
		case ReportsTypes.GetFlightDetails.SUCCESS:
			return {
				...state,
				flights: { ...state.flights, [action.requestPayload]: action.payload },
			}
		case ReportsTypes.GetHotelDetails.SUCCESS:
			return {
				...state,
				hotels: { ...state.hotels, [action.requestPayload]: action.payload },
			}

		case ReportsTypes.GetCarDetails.SUCCESS:
			return {
				...state,
				cars: { ...state.cars, [action.requestPayload]: action.payload },
			}
		case ReportsTypes.GetRailDetails.SUCCESS:
			return {
				...state,
				rails: { ...state.rails, [action.requestPayload]: action.payload },
			}
		case ReportsTypes.GetTravelerDetails.SUCCESS:
			return {
				...state,
				travelers: { ...state.travelers, [action.requestPayload]: action.payload[0] },
			}
	}
	return state
}

export default reportsReducer
